module.exports = __webpack_public_path__ + "static/media/skyshowtimebackground.f3ea868e.jpg";